
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/student/landing/blog/[slug]",
      function () {
        return require("private-next-pages/[lang]/student/landing/blog/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/student/landing/blog/[slug]"])
      });
    }
  